/**
 * The developer-owned composition file of the frontend: the ONE place where this project registers
 * its own wiring. Generated composition files (`routes.ts`, `navigation-data.ts`,
 * `aurora-widget.providers.ts`, `aurora-port.providers.ts`) import these exports. The routes come
 * before the package routes, so one of yours can claim a path ('/' included); every other export is
 * spread after the entries of the installed packages. An install never rewrites what you put here.
 *
 * Belongs here: the routes of your bounded contexts, their navigation entries and icons, their
 * widget providers and any extra application provider (a port binding of your own, for example).
 * `catalyst generate` registers your bounded contexts here.
 * Does NOT belong here: anything generated or owned by a package (`catalyst add` registers it
 * for you), and the cross-bounded-context logic itself, which stays in its own module.
 */
import type { EnvironmentProviders, Provider } from '@angular/core';
import type { Routes } from '@angular/router';
import type { NavItem } from './domains/admin/layout/sidebar/types';

/** Lazy routes mounted under the admin layout, before the package routes. */
export const projectRoutes: Routes = [];

/** Sidebar entries per section, spread last in the matching section of `navigationData`. */
export const projectNavigation: Record<
  'projects' | 'navMain' | 'navSecondary' | 'packages',
  NavItem[]
> = {
  projects: [],
  navMain: [],
  navSecondary: [],
  packages: [],
};

/** Icons of the entries above, merged into `navigationIcons` (`provideIcons` input). */
export const projectNavigationIcons: Record<string, string> = {};

/** Widget providers of your bounded contexts, merged into `auroraWidgetProviders`. */
export const projectWidgetProviders: EnvironmentProviders[] = [];

/** Extra application providers, spread last in `auroraPortProviders` so they win a token. */
export const projectProviders: Array<EnvironmentProviders | Provider> = [];
